<script setup lang="ts">
import { JSTAKING_SERVER_NAME, VALIDATOR_APY } from '~/config'

const validatorsStore = useValidatorsStore()
const validator = computed(() => validatorsStore.jstakingValidator)
const apy = computed(() => validator.value?.apyTotal || VALIDATOR_APY)
const svName = computed(() => validator.value?.svName || JSTAKING_SERVER_NAME)

const monitoringLink = computed(() =>
  `https://solana.thevalidators.io/d/e-8yEOXMwerfwe/solana-monitoring?orgId=2&refresh=30s&from=now-3h&to=now&var-cluster=mainnet-beta&var-server=${svName.value}`,
)
</script>

<template>
  <section id="first-section">
    <div class="first-section__content">
      <div class="first-section__logo">
        <i-app-solana-full />
      </div>
      <div class="first-section__title">
        <span>Trusted.</span>
        <span>Stable.</span>
        <span>Secure.</span>
      </div>
      <div class="first-section__description">
        <p>JStaking is a battle-tested validator, proudly among the first to secure the Solana blockchain.</p>
      </div>
      <div class="first-section__info">
        <div class="info-col">
          <div class="info__row">
            <span class="info__value">0.0%</span>
          </div>
          <div class="info__label">
            COMMISSION
          </div>
        </div>
        <div class="info-col">
          <div class="info__row">
            <span class="info__value">{{ apy.toFixed(2) }}%</span>
          </div>
          <div class="info__label">
            APY
          </div>
        </div>
        <div class="info-col">
          <div class="info__row">
            <app-btn
              class="monitoring-btn"
              variant="outline"
              :href="monitoringLink"
              target="_blank"
            >
              Monitoring
            </app-btn>
          </div>
        </div>
      </div>
    </div>
    <stake-box />
  </section>
</template>

<style lang="scss">
#first-section {
  display: flex;
  flex-direction: row;
  padding-right: 12px;
  gap: 34px;

  @media (max-width: $breakpoint-sm) {
    flex-direction: column;
    padding: 0;
  }

  .first-section {
    &__title {
      margin-top: 24px;
      display: flex;
      flex-direction: column;
      gap: 12px;

      @media (max-width: $breakpoint-xs) {
        margin-top: 0;
      }

      span {
        font-size: 80px;
        font-weight: 900;
        line-height: 59.9px;
        letter-spacing: -5.77px;
        color: $green;

        @media (max-width: $breakpoint-xs) {
          margin-top: 8px;
        }
        @media (max-width: $breakpoint-small) {
          font-size: 64px;
          line-height: 45px;
        }

        &:last-child {
          color: $blue;
        }
      }
    }

    &__logo {
      display: flex;
      @media (max-width: $breakpoint-sm) {
        justify-content: center;
      }
    }

    &__content {
      display: flex;
      flex-direction: column;

      @media (max-width: $breakpoint-sm) {
        text-align: center;
        gap: 16px;
      }
    }

    &__description {
      margin: 30px 0 24px;
      @media (max-width: $breakpoint-xs) {
        margin: 16px 0 0 0;
      }
      p {
        font-size: 21px;
        font-weight: 500;
        line-height: 26px;
        letter-spacing: 0.21px;
        margin: 0;
        text-align: left;

        @media (max-width: $breakpoint-sm) {
          text-wrap: balance;
          text-align: center;
        }

        @media (max-width: $breakpoint-xs) {
          font-size: 19px;
          line-height: 24px;
        }
      }
    }

    &__info {
      display: flex;
      gap: 48px;

      @media (max-width: $breakpoint-sm) {
        justify-content: center;
      }

      @media (max-width: $breakpoint-xs) {
        order: -1;
        margin-bottom: 22px;
        flex-wrap: wrap;
        gap: 38px;
      }

      .info-col {
        position: relative;
        display: flex;
        flex-direction: column;
        text-align: center;

        &:not(:last-child) {
          &::after {
            content: '';
            position: absolute;
            top: 0;
            right: -24px;
            width: 1px;
            height: 100%;
            background-color: $gray-02;
          }
        }

        @media (max-width: $breakpoint-xs) {
          &:nth-child(2) {
            &::after {
              display: none;
            }
          }

          &:nth-child(3) {
            width: 100%;
            margin-top: -6px;

            .q-btn {
              height: 46px;
              padding: 0 48px;

              &__content {
                font-size: 14px;
              }
            }
          }
        }
      }

      .info__value {
        color: $black;
        text-align: center;
        font-size: 32px;
        font-weight: 600;
        line-height: normal;
      }

      .info__label {
        color: $gray-01;
        text-align: center;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        text-transform: uppercase;
        font-size: 14px;

        &.label-small {
          font-size: 11px;
          margin-right: 8px;
          letter-spacing: -0.22px;
        }
      }
    }
  }
}
</style>
